import {
  ADD_CUSTOM_LICENSE,
  ADD_CUSTOM_LICENSE_SUCCESSFUL,
  ADD_CUSTOM_LICENSE_FAILURE,
  GET_CUSTOM_LICENSES,
  GET_CUSTOM_LICENSES_SUCCESSFUL,
  GET_CUSTOM_LICENSES_FAILURE,
  UPDATE_CUSTOM_LICENSE,
  UPDATE_CUSTOM_LICENSE_SUCCESSFUL,
  UPDATE_CUSTOM_LICENSE_FAILURE,
  DELETE_CUSTOM_LICENSE,
  DELETE_CUSTOM_LICENSE_SUCCESSFUL,
  DELETE_CUSTOM_LICENSE_FAILURE,
  CLEAR_ALL_MESSAGES,
  CLEAR_ALL_MESSAGES_SUCCESS,
  CLEAR_SUCCESS_MESSAGES,
  CLEAR_SUCCESS_MESSAGES_SUCCESS,
  CLEAR_FAILURE_MESSAGES,
  CLEAR_FAILURE_MESSAGES_SUCCESS,
} from "./actionTypes";

const initialState = {
  isAddingCustomLicense: false,
  addCustomLicenseError: null,
  addCustomLicenseMessage: null,

  isUpdatingCustomLicense: false,
  updateCustomLicenseError: null,
  updateCustomLicenseMessage: null,

  isDeletingCustomLicense: false,
  deleteCustomLicenseError: null,
  deleteCustomLicenseMessage: null,

  isGettingCustomLicenses: false,
  getCustomLicensesError: null,
  getCustomLicensesMessage: null,
};

const customLicense = (state = initialState, action) => {
  console.log("Reducer, action: " + action);
  switch (action.type) {
    case ADD_CUSTOM_LICENSE:
      console.log("Reducer -> ADD_CUSTOM_LICENSE called with custom license :: ", action.payload.customLicense);
      state = {
        ...state,
        isAddingCustomLicense: true,
        addCustomLicenseError: null,
        addCustomLicenseMessage: null,
        customLicense: action.payload.customLicense
      };
      break;
    case ADD_CUSTOM_LICENSE_SUCCESSFUL:
      console.log(
        "Reducer -> ADD_CUSTOM_LICENSE_SUCCESSFUL called"
      );
      state = {
        ...state,
        isAddingCustomLicense: false,
        addCustomLicenseMessage: "Custom license was successfully added !",
      };
      break;
    case ADD_CUSTOM_LICENSE_FAILURE:
      console.log(
        "Reducer -> ADD_CUSTOM_LICENSE_FAILURE called with error :: ",
        action.payload.error
      );
      state = {
        ...state,
        isAddingCustomLicense: false,
        addCustomLicenseError: action.payload.error,
      };      
      break;
    case GET_CUSTOM_LICENSES:
      console.log(
        "Reducer -> GET_CUSTOM_LICENSES called with orgcode = ", action.payload.orgcode);
      state = {
        ...state,
        isGettingCustomLicenses: true,
        getCustomLicensesError: null,
        orgcode: action.payload.orgcode,
      };      
      break;
    case GET_CUSTOM_LICENSES_SUCCESSFUL:
      console.log(
        "Reducer -> GET_CUSTOM_LICENSES_SUCCESSFUL called with custom license :: ",
        action.payload.customLicenses
      );
      state = {
        ...state,
        isGettingCustomLicenses: false,
        getCustomLicensesError: null,
        customLicenses: action.payload.customLicenses,
        getCustomLicensesMessage: "Custom license was successfully retrieved!"
      };      
      break;
    case GET_CUSTOM_LICENSES_FAILURE:
      console.log(
        "Reducer -> GET_CUSTOM_LICENSES_FAILURE called with error :: ",
        action.payload.error
      );
      state = {
        ...state,
        isGettingCustomLicenses: false,
        getCustomLicensesError: action.payload.error,
      };      
      break;
    case UPDATE_CUSTOM_LICENSE:
      console.log(
        "Reducer -> UPDATE_CUSTOM_LICENSE called with custom license :: ",
        action.payload.customLicense
      );
      state = {
        ...state,
        isUpdatingCustomLicense: true,
        updateCustomLicenseError: null,
        customLicense: action.payload.customLicense,
      };      
      break;
    case UPDATE_CUSTOM_LICENSE_SUCCESSFUL:
      console.log("Reducer -> UPDATE_CUSTOM_LICENSE_SUCCESSFUL called");
      state = {
        ...state,
        isUpdatingCustomLicense: false,
        updateCustomLicenseError: null,
        updateCustomLicenseMessage: "Custom license was successfully updated!",
      };      
      break;
    case UPDATE_CUSTOM_LICENSE_FAILURE:
      console.log(
        "Reducer -> ADD_CUSTOM_LICENSE_FAILURE called with error :: ",
        action.payload.error
      );
      state = {
        ...state,
        isUpdatingCustomLicense: false,
        updateCustomLicenseError: action.payload.error,
      };      
      break;
    case DELETE_CUSTOM_LICENSE:
      console.log("Reducer -> DELETE_CUSTOM_LICENSE called");
      state = {
        ...state,
        isDeletingCustomLicense: true,
        deleteCustomLicenseError: null,
      };      
      break;
    case DELETE_CUSTOM_LICENSE_SUCCESSFUL:
      console.log(
        "Reducer -> DELETE_CUSTOM_LICENSE_SUCCESSFUL called");
      state = {
        ...state,
        isDeletingCustomLicense: false,
        deleteCustomLicenseMessage: "Custom License Deleted Successfully",
        deleteCustomLicenseError: null,
      };      
      break;
    case DELETE_CUSTOM_LICENSE_FAILURE:
      console.log(
        "Reducer -> DELETE_CUSTOM_LICENSE_FAILURE called with error :: ",
        action.payload.error
      );
      state = {
        ...state,
        isDeletingCustomLicense: false,
        deleteCustomLicenseError: action.payload.error,
      };      
      break;
    case CLEAR_ALL_MESSAGES_SUCCESS:
      state = {
        ...state,
        addCustomLicenseMessage: null,
        updateCustomLicenseMessage: null,
        deleteCustomLicenseMessage: null,
        getCustomLicensesMessage: null,

        addCustomLicenseError: null,
        updateCustomLicenseError: null,
        deleteCustomLicenseError: null,
        getCustomLicensesError: null,
      };      
      break;
    case CLEAR_SUCCESS_MESSAGES_SUCCESS:
      state = {
        ...state,
        addCustomLicenseMessage: null,
        updateCustomLicenseMessage: null,
        deleteCustomLicenseMessage: null,
        getCustomLicensesMessage: null,
      };      
      break;
    case CLEAR_FAILURE_MESSAGES_SUCCESS:
      state = {
        ...state,
        addCustomLicenseError: null,
        updateCustomLicenseError: null,
        deleteCustomLicenseError: null,
        getCustomLicensesError: null,
      };      
      break;
    default:
      return state;
  }
  return state;
}


export default customLicense;